import PropTypes from 'prop-types';
import React from 'react';
import Button from '../components/Button';
import { Color } from '../../constants/components';

const RefreshButton = ({ onClick, isPrimary }) => (
    <Button
        onClick={onClick}
        isPrimary={isPrimary}
        className="modal-btn"
        text="Refresh"
        color={Color.DARK_GREY}
        ariaLabel="Refresh"
    />
);

RefreshButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    isPrimary: PropTypes.bool.isRequired,
};

export default RefreshButton;
